// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "-legacy." + {"132":"65a8c3f6","415":"3f1812bb","606":"515a5794","838":"72d1a29b"}[chunkId] + ".js";
};